import FormLocationContent from './components/Content/index.js'
import FormLocationModalPopover from './components/ModalPopover/index.js'
import FormLocationPopover from './components/Popover/index.js'

export const BASE_CLASS = 'mt-FormLocation'

export const DESIGNS = {
  BASIC: 'basic',
  MODAL_POPOVER: 'modalPopover',
  RIGHT_POPOVER: 'rightPopover'
}

export const COMPONENTS_BY_DESIGN = {
  [DESIGNS.BASIC]: FormLocationContent,
  [DESIGNS.RIGHT_POPOVER]: FormLocationPopover,
  [DESIGNS.MODAL_POPOVER]: FormLocationModalPopover
}
